import {OnlineItemsList} from '@/containers/OrderContainer/OnlineOrders/OnlineItemsList/OnlineItemsList'
import {PageContainer} from '@/components/organisms'
import {PageHeader} from 'pepsico-ds'

export const OnlineItems = () => {
  return (
    <div>
      <div className="flex flex-row justify-between">
        <PageHeader title="Order item number " />
      </div>
      <PageContainer data-testid="online-order-page-content">
        <OnlineItemsList />
      </PageContainer>
    </div>
  )
}
